import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkService } from './logic/network.service';
import { NetworkLogicService } from './logic/network/network-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
     { provide: NetworkService, useClass: NetworkLogicService },
  ]
})
export class NetworkModule {}
